import { EntityType, LanguageType } from '@/__generated__/gateway/graphql';
import { useProductStore } from '@/shared/pinia/modules/product';

import { getLanguageType } from './helpers';

/**
 * Parses `window.Shopify.locale` to a `LanguageType`, with a fallback to `LanguageType.En`.
 */
export const getLanguageFromContext = () =>
  getLanguageType(window.Shopify.locale, LanguageType.En);

/**
 * Returns productGroupId
 */
export const getEntityIdFromContext = () => {
  const productStore = useProductStore();

  if (window.Hobbii?.productPage?.isKit) {
    return (
      productStore.relatedPattern?.productGroupId ??
      productStore.resolvedEntityId
    );
  }

  return productStore.resolvedEntityId;
};

/**
 * Returns Product, Pattern, or Kit accordingly
 */
export const getEntityFromContext = () => {
  if (window.Hobbii?.productPage?.isKit) {
    // return EntityType.Kit;
    // For now, the gateway endpoint does not support kits, so we will return Pattern for now

    return EntityType.Pattern;
  }

  if (window.Hobbii?.productPage?.isPattern) {
    return EntityType.Pattern;
  }

  // if it's not a kit or pattern, we assume it's a product, as the gateway endpoints currently only support those three types.
  return EntityType.Product;

  // TODO: return EntityType.Competition when implemented, and has a competition id?
};
